import Marquee from "react-fast-marquee";
import { MARQUEE_ITEMS } from "@/data/content";

const MarqueeStrip = ({ items = MARQUEE_ITEMS, dark = false }) => (
  <div
    data-testid="editorial-marquee"
    className={`relative overflow-hidden border-y border-white/10 py-6 ${dark ? "bg-forest-900" : "bg-forest-950"}`}
  >
    <Marquee speed={28} gradient={false} pauseOnHover>
      {items.map((item, i) => (
        <span key={i} className="mx-8 flex items-center gap-8">
          <span className="font-display text-2xl font-medium tracking-tight text-outline sm:text-3xl">
            {item}
          </span>
          <svg viewBox="0 0 12 12" className="h-3 w-3" aria-hidden="true">
            <path d="M6 0 L7.5 4.5 L12 6 L7.5 7.5 L6 12 L4.5 7.5 L0 6 L4.5 4.5 Z" fill="#F2701D" />
          </svg>
        </span>
      ))}
    </Marquee>
  </div>
);

export default MarqueeStrip;
